// プレゼントボックス（/api/presents は実装済み）。
import { api, type Present } from '../api';
import { sfx } from '../audio';
import { register } from '../router';
import { patch, refreshMe, state } from '../state';
import { esc, grantsHtml, onAct, timeAgo, until } from '../ui/dom';
import { artIcon, icon } from '../ui/icons';
import { ITEM_CELL, itemIconStyle } from '../assets';
import { openModal, toast } from '../ui/overlay';
import { errorText, loadInto } from '../ui/status';
import '../ui/fit';

register('presents', {
  title: 'プレゼント',
  mount(el) {
    el.innerHTML = `<div class="page fill"><section class="panel-paper deco list-page presents">
      <header class="screen-head"><h1 class="screen-title">${artIcon('present')}プレゼント</h1><div class="end"><button class="btn primary" data-act="all">一括受取</button></div></header>
      <div class="list-body fit-scroll"></div></section></div>`;
    const body = el.querySelector<HTMLElement>('.list-body')!;
    let list: Present[] = [];
    const render = () => {
      body.innerHTML = list.length
        ? `<ul class="list present-list">${list
            .map(
              (p) => `<li class="row pr-row"><span class="thumb pr-art" style="${itemIconStyle(ITEM_CELL.chest)}"></span><div class="grow"><b>${esc(p.title)}</b>${p.body ? `<p class="small">${esc(p.body)}</p>` : ''}${grantsHtml(p.grants)}</div>
              <small class="muted pr-time">${timeAgo(p.createdAt)}${p.expiresAt ? `<br>期限 ${until(p.expiresAt)}` : ''}</small>
              <button class="btn small primary" data-act="one" data-key="${esc(p.key)}">受取</button></li>`,
            )
            .join('')}</ul>`
        : `<div class="state-box empty">${icon('present')}<p>プレゼントはありません</p></div>`;
      (el.querySelector('[data-act="all"]') as HTMLButtonElement).disabled = !list.length;
    };
    const load = () =>
      loadInto(body, 'プレゼント', api.presents, (r) => {
        list = r.presents;
        render();
        if (state.me) patch({ me: { ...state.me, unreadPresents: list.length } });
      });
    void load();
    return onAct(el, {
      one: async (b) => {
        (b as HTMLButtonElement).disabled = true;
        try {
          const r = await api.claimPresent(b.dataset.key!);
          if (r.status === 'granted') {
            sfx('reward');
            toast('受け取りました', 'good');
          } else toast(r.status === 'expired' ? '期限が切れています' : 'すでに受け取っています');
          list = list.filter((p) => p.key !== b.dataset.key);
          render();
          void refreshMe();
        } catch (e) {
          (b as HTMLButtonElement).disabled = false;
          toast(errorText(e), 'error');
        }
      },
      all: async (b) => {
        (b as HTMLButtonElement).disabled = true;
        try {
          const r = await api.claimAll();
          sfx('reward');
          openModal(`<p>${r.claimed.length}件を受け取りました。</p>${grantsHtml(r.grants)}`, { title: '受け取り' });
          void refreshMe();
          void load();
        } catch (e) {
          (b as HTMLButtonElement).disabled = false;
          toast(errorText(e), 'error');
        }
      },
    });
  },
});
